import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Plus } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1: La Matriz de Dupes 2026',
  desc: 'El mapa para sustituir marcas caras por genéricos.',
  value: '$97',
  img: 'https://cdn.magicpatterns.com/uploads/bFJz1Bv6gWeGvRpYsagEfN/bn-1.png'
}, {
  title: 'Bono 2: Directorio Mundial de Farmacias',
  desc: 'Qué comprar en cada país.',
  value: '$67',
  img: 'https://cdn.magicpatterns.com/uploads/r5LTMSpeG92qjSqVKD1o99/bn-2.png'
}, {
  title: 'Bono 7: Cuello y Manos de Porcelana',
  desc: 'El fin de las zonas que delatan la edad.',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/81af6kCfTqcAcCXyo9gXo7/bn-3.png'
}, {
  title: 'Bono 9: Guía de Skincare para el Gym',
  desc: 'Entrena sin brotes de acné.',
  value: '$27',
  img: 'https://cdn.magicpatterns.com/uploads/oDHtpKkSVrxL7EcXtss8oL/bn-4.png'
}, {
  title: 'Bono 10: Mapa de pH de Limpiadores',
  desc: 'Protege tu manto ácido.',
  value: '$27',
  img: 'https://cdn.magicpatterns.com/uploads/jgJc7JPewnri7QDkGzNxF5/bn-5.png'
}];
export function OfferSection() {
  return <section className="py-14 md:py-24 px-6 bg-charcoal text-cream" data-id="element-93">
      <div className="max-w-5xl mx-auto" data-id="element-94">
        <div className="text-center mb-10 md:mb-16" data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-gold" data-id="element-96">
            EL PROTOCOLO DE LA PIEL DE LUJO
          </h2>
          <p className="text-xl text-cream/80" data-id="element-97">
            El sistema paso a paso para hackear la industria de la belleza.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/3SFkd3Ug74Tk38d8ci9GXG/mockup-1.png" alt="El Protocolo de la Piel de Lujo Ebook" className="w-full rounded-lg shadow-2xl shadow-black/50" data-id="element-100" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="space-y-6" data-id="element-101">
            <div className="bg-white/5 p-6 rounded-xl border border-gold/20" data-id="element-102">
              <h3 className="text-2xl font-bold mb-2 text-gold font-serif" data-id="element-103">
                Ebook Principal (60 páginas)
              </h3>
              <p className="text-lg mb-4" data-id="element-104">
                El método Skin-Cycling 2-2 con genéricos.
              </p>
              <p className="text-cream/50 line-through" data-id="element-105">Valor: $197</p>
            </div>
          </motion.div>
        </div>

        <div className="flex items-center justify-center mb-10 md:mb-16" data-id="element-106">
          <div className="h-px bg-gold/30 flex-1" data-id="element-107"></div>
          <div className="px-6 text-gold font-serif italic text-2xl" data-id="element-108">
            Más 5 Bonos Exclusivos
          </div>
          <div className="h-px bg-gold/30 flex-1" data-id="element-109"></div>
        </div>

        <div className="space-y-5 md:space-y-8" data-id="element-110">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 p-6 rounded-xl border border-white/10 flex flex-col md:flex-row gap-6 items-center" data-id="element-111">
              {bono.img ? <div className="w-full md:w-1/3 shrink-0" data-id="element-112">
                  <img src={bono.img} alt={bono.title} className="w-full rounded-lg shadow-lg" data-id="element-113" />
                </div> : <div className="w-full md:w-1/3 shrink-0 bg-white/5 rounded-lg aspect-video flex items-center justify-center border border-white/10" data-id="element-114">
                  <CheckCircle2 className="w-12 h-12 text-gold/50" data-id="element-115" />
                </div>}

              <div className="flex-1 text-center md:text-left" data-id="element-116">
                <h4 className="text-xl font-bold text-gold mb-2" data-id="element-117">
                  {bono.title}
                </h4>
                <p className="text-cream/80 text-lg mb-4" data-id="element-118">{bono.desc}</p>
                <p className="text-cream/50 line-through" data-id="element-119">
                  Valor: {bono.value}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 md:mt-20 text-center bg-gold/10 p-6 md:p-8 rounded-2xl border border-gold/30" data-id="element-120">
          <h3 className="text-2xl md:text-4xl font-bold mb-4" data-id="element-121">
            VALOR TOTAL:{' '}
            <span className="line-through text-cream/50" data-id="element-122">$452.00</span>
          </h3>
        </div>
      </div>
    </section>;
}